<template>
  <div class="page_content add_tags_popup">
    <b-modal id="addTagPopup" title="Tagging" no-close-on-backdrop no-close-on-esc centered>
      <div slot="modal-header" class="header-section">
        <div class="head_txt">
          {{ $tf('tagging') }} :: <span v-if="entityData.title">{{entityData.title}}</span>
        </div>
        <div class="btn_container">
          <button
            class="btn_close"
            @click="closeModalBox"
            :aria-label="$tf('closeAria')"
            :title="$tf('closeTitle')"
            v-b-tooltip.hover>
              <span class="ic-close"></span>
          </button>
        </div>
      </div>
      <div class="ml-3 mb-3" v-if="showSkillTagging">
        <b-input-group class="row data-row">
          <div @click.stop='openInstructionalTagType' id="instructionalTagTypeDropDown" class="form-field instructional-tag-type">
            <label for="instructional-tag-type">
              {{ $tf('selectInstructionalTagType') }}
            </label>
          </div>
          <!--
            <b-popover target="instructionalTagTypeDropDown" :show.sync='showInstructionalTagTypeDropDown' :no-fade='true' triggers="click" placement="bottomright">
                <div class='header-content-row'>
                    <span class="title">Select Instructional Tag Type</span>
                    <button class="btn_close" aria-label="close" @click="closeInstructionalTagTypeDropDown">
                       <span class="ic-close"></span>
                    </button>
                </div>
                <template v-for="areaOfStudy in formattedFacetResults.programGuideCategory" >
                    <div class="field-row"><input type="checkbox" :checked="areaOfStudy.isSelected" @input.stop="filterSelected(areaOfStudy, 'programGuideCategory')">{{areaOfStudy.term}} [{{areaOfStudy.count}}]</input></div>
                </template>
                <b-btn @click="closeInstructionalTagTypeDropDown" class="range-button">ok</b-btn>
            </b-popover>
            -->
          <div @click.stop='openCompetencyTagType' id="competencyTagTypeDropDown" class="form-field competency-tag-type" style="background: rgb(225, 225, 225);">
            <label for="competency-tag-type">
              {{ $tf('selectSkillTagType') }}
              <span class="icon-dropdown1"></span>
            </label>
          </div>
          <div id="competencyListTagPopup" class="dropdown_popover competency_popover"></div>
          <b-popover target="competencyTagTypeDropDown" :show.sync='showCompetencyTagTypeDropDown' :no-fade='true' triggers="click" container="competencyListTagPopup">
            <div class='header-content-row competency_header'>
              <span class="title">{{ $tf('selectSkillTagType') }}</span>
              <button
                class="btn_close"
                @click="closeCompetencyTagTypeDropDown(false)"
                :aria-label="$tf('closeAria')"
                :title="$tf('closeTitle')"
                v-b-tooltip.hover>
                  <span class="ic-close"></span>
              </button>
            </div>
            <template v-for="option in competencyTagTypeDropDownOptions">
              <template v-if="option.source">
                <div class="field-row">
                  <span>{{competencyTagSourceLabelMap[option.source]}}</span>
                </div>
              </template>
              <div class="field-row">
                <input type="checkbox" v-model="competencyTagTypeDropDownSelected" :value="option" :label="option.text" class="ml-4">{{option.text}}</input>
              </div>
            </template>
            <b-btn @click="closeCompetencyTagTypeDropDown(true)" class="range-button">
              {{ $tf('ok') }} 
            </b-btn>
          </b-popover>
        </b-input-group>
        <b-input-group v-if="!isShowInstructionalTagTypeSection" class="competency_tags_type">
          <template v-for="(option, index) in competencyTagTypeDropDownSelected">
            <div class="tag" :class="option.text">
              <span class="tag_name">{{option.text}}</span>
              <span class="action">
                <span
                  class="delete-icon"
                  tabindex="0"
                  @click.stop="deleteSelectedCompetencyTagType(index)"
                  :aria-label="deleteAria"
                  :title="deleteTitle"
                  v-b-tooltip.hover>
                    <span class="icon-bin" aria-hidden="true"></span>
                </span>
              </span>
            </div>
          </template>
        </b-input-group>
      </div>
      <div class="row">
        <template v-if="isShowInstructionalTagTypeSection">
          <template v-if="hideAssinedTagSectionOnShown">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 tag_types_container">
              <template v-if="tagTypeList.length > 0">
                <div>
                  <autocomplete
                    ref="autocomplete"
                    :placeholder="$tf('typeToSearchTagsPH')"
                    :source="tagTypeList"
                    input-class="form-control"
                    :results-display="formattedDisplay"
                    @selected="selectTag">
                  </autocomplete>
                </div>
                <div class="mt-3">
                  <span>If you don't remember the tags browse the Tag Types.</span>
                </div>
                <div class="mt-3">
                  <span v-if="isShowTagTypes" style="cursor: pointer;" @click="isShowTagTypes = false">
                    {{ $tf('hideInstructionalTagTypes') }}
                  </span>
                  <span v-else style="cursor: pointer;" @click="isShowTagTypes = true">
                    {{ $tf('showInstructionalTagTypes') }}
                  </span>
                </div>
                <div v-if="isShowTagTypes" class="tag_type_list">
                  <template v-for="(values, key, i) in tagTypeCategories">
                    <div :class="{'mt-3': (i > 0)}">
                      <span class="tag_type_title">{{key}}</span>
                    </div>
                    <div>
                      <autocomplete
                        :ref="`autocomplete_${i}`"
                        placeholder="type to search tags and select"
                        :source="values"
                        input-class="form-control"
                        :results-display="formattedDisplay"
                        @selected="selectTag">
                      </autocomplete>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="no_tags_message">
                  No Instructional Tag Types exposed/available for this entity.
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="col-xl-4 col-lg-5 col-md-6 col-sm-12 tag_types_container">
              <template v-if="tagTypeList.length > 0">
                <div>
                  <autocomplete
                    ref="autocomplete"
                    placeholder="type to search tags and select"
                    :source="tagTypeList"
                    input-class="form-control"
                    :results-display="formattedDisplay"
                    @selected="selectTag">
                  </autocomplete>
                </div>
                <div class="mt-3">
                  <span>If you don't remember the tags browse the Tag Types.</span>
                </div>
                <div class="mt-3">
                  <span v-if="isShowTagTypes" style="cursor: pointer; color: #619fba;" @click="isShowTagTypes = false">Hide Instructional Tag Types</span>
                  <span v-else style="cursor: pointer; color: #619fba;" @click="isShowTagTypes = true">Show Instructional Tag Types</span>
                </div>
                <div v-if="isShowTagTypes" class="tag_type_list">
                  <template v-for="(values, key, i) in tagTypeCategories">
                    <div :class="{'mt-3': (i > 0)}">
                      <span class="tag_type_title">{{key}}</span>
                    </div>
                    <div>
                      <autocomplete
                        :ref="`autocomplete_${i}`"
                        placeholder="type to search tags and select"
                        :source="values"
                        input-class="form-control"
                        :results-display="formattedDisplay"
                        @selected="selectTag">
                      </autocomplete>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="no_tags_message">
                  No Instructional Tag Types exposed/available for this entity.
                </div>
              </template>
            </div>
          </template>
          <div class="col-xl-8 col-lg-7 col-md-6 col-sm-12" :class="{'d-none': hideAssinedTagSectionOnShown}">
            <div class="tags_section">
              <div class="heading">
                <span class="head_txt" role="heading">Assigned Tags</span>
              </div>
              <div class="tag_section_container">
                <template v-for="(values, key, i) in appliedTagMap">
                  <div v-if="values.length > 0">
                    <div class="tag_type_head" :class="{'': (values.length > 0 || getTagTypeFromTagTypeList(key))}">{{getTagType(values, key, i)}}</div>
                    <div class="tags_section">
                      <div class="tags_container" :class="{'': (values.length > 0 || getTagTypeFromTagTypeList(key))}">
                        <div class="tag" v-for="(tag, j) in values" v-bind:title="tag.name" v-bind:aria-label="tag.name">
                          <span class="tag_name instructional_tag"> {{tag.name}} </span>
                          <span class="action">
                            <button class="ic_btn ic_delete" @click="removeTag(values, key, j)" title="delete this tag" v-b-tooltip.hover>
                              <span class="icon-bin" aria-hidden="true"></span>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- Competency Tags -->
                <template v-for="(values, key, i) in careerCompetencies">
                  <div v-if="values.length > 0">
                    <div class="tag_type_head">{{key}}</div>
                    <div class="tags_section">
                      <div class="tags_container">
                        <div class="tag" v-for="(specialTag, j) in values" v-bind:title="specialTag.name" v-bind:aria-label="specialTag.name" :class="specialTag.tagType">
                          <span class="tag_name competency_tag">{{specialTag.name}}</span>
                          <span class="tag_lavel" v-if="showSkillLevel && specialTag.fulfillLevels.length > 0">
                          {{specialTag.fulfillLevels[0]}}
                          </span>
                          <span class="action">
                          <span class="delete-icon" @click="removeCompetencyTag(values, specialTag, j)" title="delete tag">
                          <i class="icon-bin" aria-hidden="true"></i>
                          </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-xl-7 col-lg-5 col-md-6 col-sm-12">
            <div class="tags_section">
              <div class="heading">
                <div class="head_txt" role="heading">Tags</div>
                <div class="srh_bx">
                  <input v-model="displayTitle" v-on:keyup="keyupEvent" placeholder="type to narrow list" aria-label="type to narrow list">
                  <div class="clear-btn" v-if="this.displayTitle.length > 0" >
                    <b-btn @click="clearSearch" aria-label="clear" title="clear">
                      <span>x</span>
                    </b-btn>
                  </div>
                </div>
              </div>
              <div class="heading p-3" style="background: #fff; border-bottom: 1px solid #ebebeb;" v-if="competencyTags.length > 0">
                <div class="float-left">
                  <span><b>{{numberOfElements}}</b> of <b>{{Number(totalElements).toLocaleString()}}</b> tags. You can start typing above to narrow the list.</span>
                </div>
                <div class="float-right btn_container pagination_sty3 mr-2" style="max-width: none;">
                  <button type="button" :disabled="firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                  <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
                  <button type="button" :disabled="lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                </div>
              </div>
              <div class="tag_section_container">
                <template v-if="competencyTags.length > 0">
                  <div class="row type_list_row" v-for="(competencyTag, index) in competencyTags">
                    <template v-if="showSkillLevelDropDown && (competencyTag.source === 'ONET' || competencyTag.source === 'COS')">
                      <div class="col-xl-2 col-lg-6 col-md-6 col-sm-6 btn_container">
                        <b-button variant="primary" size="sm" @click.stop="applyCompetencyTag(competencyTag)" :disabled="competencyTag.skillApplied || !competencyTag.skillLevel">apply</b-button>
                      </div>
                      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 select_bx_container">
                        <b-form-select v-model="competencyTag.skillLevel" :options="skillLevelOptions" size="sm" :disabled="competencyTag.skillApplied"></b-form-select>
                      </div>
                      <div class="col-xl-7 col-lg-12 col-md-12 col-sm-12 tag_name_container">
                        <div>{{competencyTag.displayTitleForTeacher}}</div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="col-2 btn_container">
                        <b-button variant="primary" size="sm" @click.stop="applyCompetencyTag(competencyTag)" :disabled="competencyTag.skillApplied">apply</b-button>
                      </div>
                      <div class="col-10 tag_name_container">
                        <div>{{competencyTag.displayTitleForTeacher}}</div>
                      </div>
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="loading-spinner" v-if="isLoading">
                    <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                      <div class="text-center" style="color: #FFF; overflow: hidden;">
                        <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                      </div>
                    </b-modal>
                  </div>
                  <div class="no_tags_message" v-else>
                    Competency Tags Not Found.
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="col-xl-5 col-lg-7 col-md-6 col-sm-12">
            <div class="tags_section">
              <div class="heading">
                <span class="head_txt" role="heading">Assigned Tags</span>
              </div>
              <div class="tag_section_container">
                <template v-for="(values, key, i) in appliedTagMap">
                  <div v-if="values.length > 0">
                    <div class="tag_type_head" :class="{'': (values.length > 0 || getTagTypeFromTagTypeList(key))}">{{getTagType(values, key, i)}}</div>
                    <div class="tags_section">
                      <div class="tags_container" :class="{'': (values.length > 0 || getTagTypeFromTagTypeList(key))}">
                        <div class="tag" v-for="(tag, j) in values" v-bind:title="tag.name" v-bind:aria-label="tag.name">
                          <span class="tag_name instructional_tag"> {{tag.name}} </span>
                          <span class="action">
                          <span class="delete-icon" @click="removeTag(values, key, j)" title="delete tag">
                          <i class="icon-bin" aria-hidden="true"></i>
                          </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- Competency Tags -->
                <template v-for="(values, key, i) in careerCompetencies">
                  <div v-if="values.length > 0">
                    <div class="tag_type_head">{{key}}</div>
                    <div class="tags_section">
                      <div class="tags_container">
                        <div class="tag" v-for="(specialTag, j) in values" v-bind:title="specialTag.name" v-bind:aria-label="specialTag.name" :class="specialTag.tagType">
                          <span class="tag_name competency_tag">{{specialTag.name}}</span>
                          <span class="tag_lavel" v-if="showSkillLevel && specialTag.fulfillLevels.length > 0">
                          {{specialTag.fulfillLevels[0]}}
                          </span>
                          <span class="action">
                          <span class="delete-icon" @click="removeCompetencyTag(values, specialTag, j)" title="delete tag">
                          <i class="icon-bin" aria-hidden="true"></i>
                          </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div slot="modal-footer">
        <template v-if="entityData.uuid">
          <b-button variant="primary" size="sm" class="float-right" :disabled="!isDataLoaded" @click="saveAndDone">save & done</b-button>
        </template>
        <template v-else>
          <b-button variant="primary" size="sm" class="float-right" :disabled="!isDataLoaded" @click="applyTagToEntity">ok</b-button>
        </template>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { PACKAGE } from '../../../package_constants'
  import Autocomplete from 'vuejs-auto-complete'
  import _ from 'lodash'

  export default {
    name: 'add-tag-popup',
    props: ['entityData'],
    components: {
      Autocomplete
    },
    data: () => {
      return {
        tagTypeList: [],
        isLoading: true,
        isDataLoaded: false,
        tagTypeCategories: {},
        isShowTagTypes: false,
        appliedTagMap: {},
        showInstructionalTagTypeDropDown: false,
        showCompetencyTagTypeDropDown: false,
        isShowInstructionalTagTypeSection: true,
        competencyTagTypesMap: {
          'HARD': 'Hard Skills',
          'SOFT': 'Soft Skills',
          'CERTIFICATION': 'Certifications',
          'SKILL': 'Skills',
          'ABILITY': 'Abilities',
          'KNOWLEDGE': 'Knowledge',
          'BASELINE': 'Foundational Skills',
          'Specialized Skill': 'Specialized Skills',
          'Common Skill' : 'Common Skills',
          'Certification':'Certification Skills'
        },
        competencyTagTypeDropDownOptions: [],
        competencyTagTypeDropDownSelected: [],
        careerCompetencies: {},
        competencyTags: [],
        displayTitle: '',
        page: 0,
        firstPage: true,
        lastPage: false,
        totalElements: 0,
        numberOfElements: 0,
        competencyTagSourceLabelMap: {
          'EMSI': 'EMSI',
          'COS': 'Career One Stop',
          'LIGHTCAST': 'LIGHTCAST',
          'BGT': 'Burning Glass Technologies',
          'MIT': 'MIT',
          'NACE': 'NACE'
        }
      }
    },

    mounted () {
      this.tagTypeList = []
      this.careerCompetencies = {}
      let careerCompetenciesList = []
      this.appliedTagMap = _.cloneDeep(this.entityData.appliedTagMap)
      let careerCompetenciesMap = this.entityData.careerCompetenciesMap
      if (careerCompetenciesMap) {
        let entries = Object.entries(careerCompetenciesMap).sort((a, b) => a[0].localeCompare(b[0]))
        if (entries && entries.length > 0) {
          for (const [key, values] of entries) {
            if (key) {
              values.forEach(value => {
                careerCompetenciesList.push(value)
              })
            }
          }
        } else {
          careerCompetenciesList = _.cloneDeep(this.entityData.careerCompetenciesList)
        }
      } else {
        careerCompetenciesList = _.cloneDeep(this.entityData.careerCompetenciesList)
      }
      if (careerCompetenciesList && careerCompetenciesList.length > 0) {
        this.isDataLoaded = true
        careerCompetenciesList.forEach(specialTag => {
          let category = specialTag.tagType
          let competencies = Object.keys(this.careerCompetencies)
          if (competencies.includes(category)) {
            this.careerCompetencies[category].push(specialTag)
          } else {
            let careerCompetencies = [specialTag]
            this.$set(this.careerCompetencies, category, careerCompetencies)
          }
        })
      }
      this.loadPublicInstitutionDetail().then(res => {
        this.loadCategorisedTags({uuid: res.uuid, entityType: this.entityData.type}).then(items => {
          this.tagTypeList = items
          if (items && items.length > 0) {
            this.isDataLoaded = true
            this.tagTypeCategories = {}
            items.forEach((item) => {
              let tagType = item.tagType
              if (this.tagTypeCategories.hasOwnProperty(tagType)) {
                this.tagTypeCategories[tagType].push(item)
              } else {
                this.tagTypeCategories[tagType] = [item]
              }
            })
          }
        })
      })
      if (this.showSkillTagging) {
        let source = this.skillSource
        this.loadSkillTypes(source).then(types => {
          if (types) {
            types.forEach((type, i) => {
              let label = this.competencyTagTypesMap[type]
              let typeWithSource = type + '_' + source
              let data = (i === 0) ? {source: source, text: label, value: typeWithSource} : {text: label, value: typeWithSource}
              this.competencyTagTypeDropDownOptions.push(data)
            })
          }
        })
        let otherSource = this.otherSkillSource
        if (otherSource) {
          this.loadSkillTypes(otherSource).then(types => {
            if (types) {
              types.forEach((type, i) => {
                let label = this.competencyTagTypesMap[type]
                let typeWithSource = type + '_' + otherSource
                let data = (i === 0) ? {source: otherSource, text: label, value: typeWithSource} : {text: label, value: typeWithSource}
                this.competencyTagTypeDropDownOptions.push(data)
              })
            }
          })
        }
      }
    },

    methods: {
      ...mapActions([
        'loadSkillTypes',
        'loadCategorisedTags',
        'loadPublicInstitutionDetail',
        'loadCompetencySkillsBasedOnTypes',
        'saveAppliedTagMap'
      ]),

      formattedDisplay (result) {
        return result.tagType + ': <strong>' + result.tagValue + '<strong>'
      },

      selectTag (item) {
        let data = item.selectedObject
        let category = data.category
        let tag = {auto: false, name: data.tagValue, category: category, tagType: data.tagType}
        let categories = Object.keys(this.appliedTagMap)
        if (categories.includes(category)) {
          let items = this.appliedTagMap[category]
          let found = items.find((item) => {
            return (tag.name === item.name)
          })
          if (!found) {
            this.appliedTagMap[category].push(tag)
          }
        } else {
          let tags = [tag]
          this.$set(this.appliedTagMap, category, tags)
        }
      },

      closeModalBox () {
        this.$root.$emit('bv::hide::modal', 'addTagPopup')
        this.$parent.isShowTagPopup = false
        this.$emit('closeAddTagModal')
      },

      getTagTypeFromTagTypeList (key) {
        return this.tagTypeList.find((item) => {
          return item[key]
        })
      },

      getTagType (values, key, index) {
        if (values && values.length > 0) {
          let value = values.find(value => {
            return value.hasOwnProperty('tagType')
          })
          if (value) {
            return value.tagType
          }
        }
        let tagTypes = this.getTagTypeFromTagTypeList(key)
        if (tagTypes) {
          return tagTypes.tagType
        }
        let prefix = 'custom_'
        let tagType = (key.indexOf(prefix) === -1) ? key : key.substring(prefix.length)
        let suffix = '_8_to_be_facted_8'
        if (tagType.indexOf(suffix) !== -1) {
          tagType = tagType.replace(suffix, '').split('_1_').join(' ')
        }
        return this.titleCase(tagType)
      },

      titleCase (value) {
        return value.toLowerCase().split(' ').map((word) => {
          return (word.charAt(0).toUpperCase() + word.slice(1))
        }).join(' ')
      },

      removeTag (values, key, index) {
        values.splice(index, 1)
      },

      applyTagToEntity () {
        Object.assign(this.entityData.appliedTagMap, this.appliedTagMap)
        this.$emit('applyTagToEntity')
        this.closeModalBox()
      },

      saveAndDone () {
        Object.assign(this.entityData.appliedTagMap, this.appliedTagMap)
        let careerCompetenciesMap = {}
        let careerCompetenciesList = []
        for (let key in this.careerCompetencies) {
          let specialTags = this.careerCompetencies[key]
          specialTags.forEach(specialTag => {
            let source = specialTag.source
            let competencies = Object.keys(careerCompetenciesMap)
            if (competencies.includes(source)) {
              careerCompetenciesMap[source].push(specialTag)
            } else {
              this.$set(careerCompetenciesMap, source, [specialTag])
            }
            careerCompetenciesList.push(specialTag)
          })
        }
        this.entityData.careerCompetenciesList = careerCompetenciesList
        this.entityData.careerCompetenciesMap = careerCompetenciesMap
        this.saveAppliedTagMap(this.entityData).then(res => {
          if (res) {
            this.closeModalBox()
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Added tag(s) saved successfully.'
            })
          }
        })
        setTimeout(() => {
          if (this.entityData.isRefresh) {
            if (this.$router.currentRoute.path === '/search/result') {
              return this.$router.push({name: 'tagSearchResults', query: {_: new Date().getTime()}})
            }
            if (this.$router.currentRoute.path === '/job/board') {
              return this.$router.push({name: 'jobBoard', query: {_: new Date().getTime()}})
            }
            if (this.$router.currentRoute.path === '/manage/jobs') {
              return this.$router.push({name: 'manageJobs', query: {_: new Date().getTime()}})
            }
            if (this.$router.currentRoute.path === '/discover') {
              return this.$router.push({name: 'results', query: {_: new Date().getTime()}})
            }
          }
        }, 1500)
      },

      showLoader () {
        this.isLoading = true
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },

      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
        this.isLoading = false
      },

      openInstructionalTagType () {
        this.showInstructionalTagTypeDropDown = true
        this.isShowInstructionalTagTypeSection = true
      },

      closeInstructionalTagTypeDropDown () {
        this.showInstructionalTagTypeDropDown = false
      },

      openCompetencyTagType () {
        this.showCompetencyTagTypeDropDown = true
      },

      closeCompetencyTagTypeDropDown (isOk) {
        this.showCompetencyTagTypeDropDown = false
        if (isOk) {
          if (this.competencyTagTypeDropDownSelected.length > 0) {
            this.populateCompetencySkill()
            this.isShowInstructionalTagTypeSection = false
          } else {
            this.isShowInstructionalTagTypeSection = true
          }
        }
      },

      prev () {
        this.page -= 1
        if (this.displayTitle.length > 0) {
          this.populateCompetencySkill(this.displayTitle)
        } else {
          this.populateCompetencySkill()
        }
      },

      next () {
        this.page += 1
        if (this.displayTitle.length > 0) {
          this.populateCompetencySkill(this.displayTitle)
        } else {
          this.populateCompetencySkill()
        }
      },

      populateCompetencySkill (keyword) {
        let types = []
        this.competencyTagTypeDropDownSelected.forEach((option) => {
          types.push(option.value)
        })
        this.showLoader()
        this.loadCompetencySkillsBasedOnTypes({types: types.join(), keyword: keyword, page: this.page}).then(res => {
          this.isDataLoaded = true
          this.page = res.number
          this.firstPage = res.first
          this.lastPage = res.last
          this.totalElements = res.totalElements
          let offset = res.pageable.offset
          this.numberOfElements = ((offset + 1) + ' - ' + (res.numberOfElements + offset))
          this.competencyTags = res.content
          let competencies = Object.keys(this.careerCompetencies)
          this.competencyTags.forEach(competencyTag => {
            if (competencies.length > 0) {
              competencies.forEach(category => {
                let specialTags = this.careerCompetencies[category]
                let results = specialTags.filter(specialTag => {
                  return (competencyTag.uuid === specialTag.uuid)
                })
                if (results.length > 0) {
                  competencyTag.skillApplied = true
                  competencyTag.skillLevel = results[0].fulfillLevels[0]
                }
              })
            }
          })
          this.hideLoader()
        })
      },

      deleteSelectedCompetencyTagType (index) {
        this.competencyTagTypeDropDownSelected.splice(index, 1)
        this.closeCompetencyTagTypeDropDown(true)
      },

      applyCompetencyTag (competencyTag) {
        let fulfillLevels = (competencyTag.skillLevel) ? [competencyTag.skillLevel] : []
        let options = this.competencyTagTypeDropDownOptions.filter(option => {
          return (competencyTag.typeWithSource.toLowerCase() === option.value.toLowerCase())
        })
        let category = options[0].text
        let source = competencyTag.source
        let specialTag = {uuid: competencyTag.uuid, name: competencyTag.displayTitleForTeacher, source: source, tagType: category, fulfillLevels: fulfillLevels}
        let competencies = Object.keys(this.careerCompetencies)
        if (competencies.includes(category)) {
          let items = this.careerCompetencies[category]
          let found = items.find((item) => {
            return (specialTag.name === item.name)
          })
          if (!found) {
            this.careerCompetencies[category].push(specialTag)
          }
          competencyTag.skillApplied = true
        } else {
          let careerCompetenciesList = [specialTag]
          this.$set(this.careerCompetencies, category, careerCompetenciesList)
          competencyTag.skillApplied = true
        }
      },

      removeCompetencyTag (values, specialTag, index) {
        values.splice(index, 1)
        this.competencyTags.forEach(competencyTag => {
          if (competencyTag.uuid === specialTag.uuid) {
            competencyTag.skillLevel = null
            competencyTag.skillApplied = false
          }
        })
      },

      keyupEvent (event) {
        this.page = 0
        this.populateCompetencySkill(this.displayTitle)
      },

      clearSearch () {
        this.page = 0
        this.displayTitle = ''
        this.populateCompetencySkill()
      }
    },

    computed: {
      ...mapState({
        'institution': state => state.institution.publicInstitution,
        'enabledFeatures': state => state.institution.enabledFeatures
      }),

      hideAssinedTagSectionOnShown () {
        if (this.entityData.hideAssinedTagsOnInit) {
          let count = 0
          for (let key in this.appliedTagMap) {
            count += this.appliedTagMap[key].length
          }
          return (count === 0)
        }
        return false
      },

      showSkillTagging () {
        let skillTaggingFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SKILL_TAGGING_FEATURE_ID]
        if (skillTaggingFeature && skillTaggingFeature.enabled) {
          let flags = skillTaggingFeature.flags
          for (var i = 0; i < flags.length; i++) {
            let flag = flags[i]
            if (flag.title.toLowerCase() === this.entityData.type) {
              return flag.enabled
            }
          }
        }
        return false
      },

      skillSource () {
        let source = 'COS'
        let skillTaggingSrcFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SKILL_TAGGING_SOURCE_FEATURE_ID]
        if (skillTaggingSrcFeature) {
          let flags = skillTaggingSrcFeature.flags
          for (let i = 0; i < flags.length; i++) {
            let flag = flags[i]
            if ((flag.title === 'sourceEMSI') && flag.enabled) {
              source = 'EMSI'
              break
            } else if ((flag.title === 'sourceBGT') && flag.enabled) {
              source = 'BGT'
              break
            } else if ((flag.title === 'sourceCOS') && flag.enabled) {
              source = 'COS'
              break
            } else if ((flag.title === 'sourceLIGHTCAST') && flag.enabled) {
              source = 'LIGHTCAST'
              break
            }
          }
        }
        return source
      },

      otherSkillSource () {
        let source
        let othSkillTaggingSrcFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.OTHER_SKILL_TAGGING_SOURCE_FEATURE_ID]
        if (othSkillTaggingSrcFeature) {
          let flags = othSkillTaggingSrcFeature.flags
          for (let i = 0; i < flags.length; i++) {
            let flag = flags[i]
            if ((flag.title === 'sourceMIT') && flag.enabled) {
              source = 'MIT'
              break
            } else if ((flag.title === 'sourceNACE') && flag.enabled) {
              source = 'NACE'
              break
            }
          }
        }
        return source
      },

      showSkillLevel () {
        return ((this.skillSource === 'ONET') || (this.skillSource === 'COS'))
      },

      showSkillLevelDropDown () {
        if (this.showSkillLevel) {
          let skillTaggingLevelsFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SKILL_TAGGING_LEVELS_FEATURE_ID]
          if (skillTaggingLevelsFeature) {
            return skillTaggingLevelsFeature.enabled
          }
        }
        return false
      },

      skillLevelOptions () {
        let skillLevelOptions = [{value: null, text: '-- Skill Level --'}]
        let skillTaggingLevelsFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SKILL_TAGGING_LEVELS_FEATURE_ID]
        if (skillTaggingLevelsFeature) {
          let flags = skillTaggingLevelsFeature.flags
          for (var i = 0; i < flags.length; i++) {
            let flag = flags[i]
            if (flag.enabled) {
              let text = (flag.label && flag.label.length > 0) ? flag.label : flag.title
              skillLevelOptions.push({text: text, value: text.substring(0, 1)})
            }
          }
        }
        return skillLevelOptions
      }
    }
  }
</script>
<style scoped>
  .instructional-tag-type {
    background: #d0eaf4;
  }
  .competency-tag-type {
    background: #ffebed;
  }
  .form-field {
    padding: 1px 13px;
    margin-right: 15px;
    color: #464646;
    cursor: pointer;
  }
  .form-field label {
    margin-top: 7px;
    font-weight: 800;
    cursor: pointer;
  }
  .competency-tag-type-container {
    margin-top: 20px;
    margin-right: 10px;
    border: 1px solid #b3b3b3;
  }
  .competency-tag-type-text {
    float: left;
    padding: 1px 6px 4px;
    border-right: 1px solid #b3b3b3;
    font-size: 15px;
    height: 27px;
    color: #303030;
    background-color: #ffebed;
  }
  .delete {
    border: 1px solid #939393;
    border-radius: 3px;
    height: 25px;
    margin: -1px -6px 0px 20px;
    background: #ffffff;
  }
  .delete-icon {
    color: #157099;
    cursor: pointer;
    font-size: 17px;
    margin: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/app/tagging/components/AddTagPopup.vue